<template lang="pug">
	div
		Alerts(ref="Alerts")

		b-form(@submit.prevent='onSubmit')
			component(:is="field.widget" v-model="form[field.name]" v-for="field in formMember" :key="field.name" :_field="field" :_checkState="checkState" :_invalidFeedback="invalidFeedback")

			div
				b-button(variant='success' type='submit' block :disabled="isSending")
					b-spinner(small label="Small Spinner" v-if="isSending")
					span(v-else) Создать участника
</template>
<script>
	import { mapState, mapActions } from 'vuex';

	import Alerts from '../../../components/Alerts'
	import modelMember from '../../../../store/models/modelMember'
	import formMember from '../../../../store/forms/formMember'

	import clearFormMixin from '@/MIXINS/clearForm'
	import formBackValidation from '@/MIXINS/formBackValidation'
	import collectFormData from '@/MIXINS/collectFormData'

	export default {
		name: 'formCreateMember',
		props: {
			_cbOK:    { type: Function, default: ()=>{}, required: false },
			_cbERR:   { type: Function, default: ()=>{}, required: false },
		},
		mixins: [
			clearFormMixin,
			formBackValidation,
			collectFormData,
		],
		components: {
			Alerts,
		},
		data: () => ({
			form: { ...modelMember },
			formMember,
			isSending: false,
		}),
		computed: {
			...mapState(['members']),
			error(){ return this.members.post.error },
		},
		methods: {
			...mapActions(['postMember']),

			cbOK(resp){
				this.$refs.Alerts.showAlert('Участник успешно создан!', 'success');
				this.isSending = false;
				this.clearForm('form');

				return resp;
			},
			cbERR(resp){
				this.isSending = false;
				this.error.non_field_errors
					? this.$refs.Alerts.showAlert(this.error.non_field_errors[0], 'error')
					: this.$refs.Alerts.showAlert(this.error.detail, 'error');
				throw resp;
			},
			onSubmit() {
				this.isSending = true;
				this.$store.dispatch('postMember', this.form)
					.then(this.cbOK).then(this._cbOK)
					.catch(this.cbERR).catch(this._cbERR);
			},
		},
	}
</script>
